<template>
  <form
    data-component="table-number-form"
    @submit.prevent="handleSubmit"
  >
    <label
      data-element="label"
      for="table-input"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    >
      Enter Table Number
    </label>
    <div
      data-element="input-group"
      class="control"
    >
      <input
        id="table-input"
        data-element="input"
        type="number"
        pattern="\d*"
        name="tableNumber"
        :value="tableNumber"
        @input="updateTableNumber($event.target.value)"
        v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
        v-modify-input-leading="{ modifyInputLeading: $store.getters['ui/getBodyCopyFontInputLeading'] }"
        autofocus
      />
      <btn
        data-element="submit-button"
        :fontStyle="{...this.$store.getters['ui/getBodyCopyFontDetail']('normal'), textSize:'18px'}"
        :backgroundColor="secondaryColor"
        text="Let's go!"
        :loading="submitted"
      />
    </div>
    <p
      data-element="error-message"
      v-if="showError"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    >
      Please enter a valid table number
    </p>
  </form>
</template>

<script>

  import Btn from '@/components/ui/Btn';

  export default {
    props: [
      'tableNumber',
      'updateTableNumber',
      'submitTableNumber',
      'submitted',
      'showError'
    ],
    components: {
      Btn
    },
    computed: {
      secondaryColor () {
        return this.$store.getters['ui/getSecondaryColor'];
      }
    },
    methods: {
      bodyCopy (fontWeightLabel) {
        return this.$store.getters['ui/getBodyCopyFontDetail'](fontWeightLabel);
      },
      handleSubmit () {
        this.submitTableNumber();
      }
    }
  }


</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  [data-component='table-number-form'] {
    flex-direction:column;
    align-items:flex-start;
    display:flex;
    padding:0 24px;
    height:100px;
    [data-element='label'] {
      color:#fff;
      width:100%;
      font-size:16px;
      text-align:center;
      margin-bottom:7px;
    }
    [data-element='input-group'] {
      display:flex;
      width:100%;
      [data-element='input'] {
        width:calc(100% - 88px);
        font-size:18px;
        font-weight:500;
        background-color:#fff;
        text-align:center;
        border-radius:0;
        &:focus {
          outline-color:#fff;
        }
        &::-ms-clear {
          display: none;
        }
        // To hide the up and down buttons
        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        -moz-appearance:textfield;
      }
      [data-element='submit-button'] {
        color:#fff;
        font-size:18px;
        width:106px;
      }
    }
    [data-element='error-message'] {
      color:#fff;
      font-size:16px;
      text-align:center;
      width:100%;
    }
  }

</style>
